import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateFuelingServicePaymentMethods } from '../../api/fueling-service.ts';
import { UpdateFuelingServicePaymentMethodsRequest } from '../../api/requests/fueling-service-request.ts';

export default function useUpdateFuelingServicePaymentMethods(): UseMutationResult<
  Awaited<ReturnType<typeof updateFuelingServicePaymentMethods>>,
  Error,
  UpdateFuelingServicePaymentMethodsRequest
> {
  return useMutation({
    mutationFn: updateFuelingServicePaymentMethods,
  });
}
